import FilterChip from "./FilterChip";

type FilterChipGroupProps<T> = {
    selectedItemIds: number[];
    allItems: T[];
    labelKey: keyof T;
    onRemove: (id: number[]) => void;
};

const FilterChipGroup = <T extends { id: number }>({
    selectedItemIds,
    allItems,
    labelKey,
    onRemove,
}: FilterChipGroupProps<T>) => {
    const handleRemoveChip = (id: number) =>
        onRemove(selectedItemIds.filter((selectedItem) => selectedItem !== id));

    return (
        <>
            {selectedItemIds.map((selectedItemId) => (
                <FilterChip
                    onRemove={() => handleRemoveChip(selectedItemId)}
                    key={`data-source-filter-chip-${selectedItemId}`}
                >
                    {`${
                        allItems.find((item) => item.id === selectedItemId)?.[
                            labelKey
                        ]
                    }` ?? "Loading..."}
                </FilterChip>
            ))}
        </>
    );
};

export default FilterChipGroup;
